/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sea_Bold_Cowfish_TrustInputs */

const fr_sea_bold_cowfish_trust = /** @type {(inputs: Sea_Bold_Cowfish_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

/**

* @param {Sea_Bold_Cowfish_TrustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sea_bold_cowfish_trust = /** @type {((inputs?: Sea_Bold_Cowfish_TrustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sea_Bold_Cowfish_TrustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sea_bold_cowfish_trust(inputs)
});